import { render } from "./SummaryCalculatedView.vue?vue&type=template&id=23f57571&scoped=true"
import script from "./SummaryCalculatedView.vue?vue&type=script&lang=js"
export * from "./SummaryCalculatedView.vue?vue&type=script&lang=js"

import "./SummaryCalculatedView.vue?vue&type=style&index=0&id=23f57571&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23f57571"]])

export default __exports__